export enum DrawerBackdropCssVars {
  /**
   * The swipe progress of the drawer gesture.
   * @type {number}
   */
  swipeProgress = '--drawer-swipe-progress',
}
